import { t } from "@lingui/macro";
import * as React from "react";
import { Path, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SessionIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Session`} {...props}>
    <G clipPath="url(#a)">
      <Path
        fill="currentColor"
        d="M11 .25a.75.75 0 0 1 .75.75v.25h1.694c1.22 0 2.306.931 2.306 2.194v10.112c0 1.263-1.086 2.194-2.306 2.194H2.556c-1.22 0-2.306-.931-2.306-2.194V3.444c0-1.263 1.086-2.194 2.306-2.194H4.25V1a.75.75 0 0 1 1.5 0v.25h4.5V1A.75.75 0 0 1 11 .25Zm-8.444 2.5c-.498 0-.806.362-.806.694v10.112c0 .332.308.694.806.694h10.888c.498 0 .806-.362.806-.694V3.444c0-.332-.307-.694-.806-.694H11.75V4a.75.75 0 0 1-1.5 0V2.75h-4.5V4a.75.75 0 0 1-1.5 0V2.75H2.556ZM5.5 9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1Zm0-3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1Zm3 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1Zm3 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
